var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiteRampAnterior(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.45863 10.0912C3.56566 9.64048 3.96829 9.32227 4.43158 9.32227H29.4936C29.9034 9.32227 30.2718 9.57236 30.423 9.95329C30.5742 10.3342 30.4777 10.7689 30.1795 11.05L27.94 13.1607C25.2096 15.7342 22.7224 18.5542 20.5101 21.5847L19.479 22.9971C19.2907 23.255 18.9906 23.4075 18.6713 23.4075H4.43158C3.96829 23.4075 3.56566 23.0893 3.45863 22.6386L3.34041 22.1407C2.43861 18.343 2.43861 14.3868 3.34041 10.5891L3.45863 10.0912ZM5.22366 11.3223C4.47753 14.6426 4.47753 18.0872 5.22366 21.4075H18.1632L18.8947 20.4055C21.1795 17.2756 23.7483 14.3632 26.5683 11.7053L26.9746 11.3223H5.22366Z",
    fill: "#647B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.617 9.97932C15.8064 10.1803 15.7971 10.4967 15.5961 10.6861L13.3567 12.7968C10.6038 15.3914 8.09626 18.2345 5.86582 21.2899L4.83474 22.7023C4.67192 22.9254 4.35912 22.9742 4.13609 22.8114C3.91305 22.6486 3.86423 22.3358 4.02705 22.1127L5.05814 20.7003C7.32484 17.5952 9.8732 14.7059 12.6708 12.0691L14.9102 9.95841C15.1112 9.76901 15.4276 9.77837 15.617 9.97932Z",
    fill: "#647B8F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiteRampAnterior);
export default __webpack_public_path__ + "static/media/bite-ramp-anterior.7e39d3b1.svg";
export { ForwardRef as ReactComponent };